import { render } from "./BeneficariesSupportView.vue?vue&type=template&id=d107c220&scoped=true"
import script from "./BeneficariesSupportView.vue?vue&type=script&lang=js"
export * from "./BeneficariesSupportView.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=d107c220&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d107c220"]])

export default __exports__